import { render, staticRenderFns } from "./ChromeText.vue?vue&type=template&id=f3679912&scoped=true&"
import script from "./ChromeText.vue?vue&type=script&lang=ts&"
export * from "./ChromeText.vue?vue&type=script&lang=ts&"
import style0 from "./ChromeText.vue?vue&type=style&index=0&id=f3679912&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3679912",
  null
  
)

export default component.exports